import React, { Fragment } from 'react';
import Safe from 'react-safe';
import PropTypes from 'prop-types';
import getConfig from 'next/config';
import Country from '../../common/models/Country';

const addAdrollScript = adrollCustomData => (
  <Fragment>
    <Safe.script type="text/javascript">
      {`
                                adroll_adv_id = "LZCSRWVVCBFVJE766TJ3OB";
                                adroll_pix_id = "PVJIWP3OQZFJTH6XDLZ253";
                                (function() {
                                    var oldonload = window.onload;
                                    window.onload = function() {
                                        __adroll_loaded = true;
                                        var scr = document.createElement("script");
                                        var host = "https://s.adroll.com";
                                        scr.setAttribute('async', 'true');
                                        scr.type = "text/javascript";
                                        scr.src = host + "/j/roundtrip.js";
                                        ((document.getElementsByTagName('head') || [null])[0] ||
                                        document.getElementsByTagName('script')[0].parentNode).appendChild(scr);
                                        if (oldonload) {
                                            oldonload()
                                        }
                                    };
                                }());
                            `}
    </Safe.script>
    {adrollCustomData && (
      <Safe.script type="text/javascript">{`adroll_custom_data = ${JSON.stringify(adrollCustomData)};`}</Safe.script>
    )}
  </Fragment>
);

const addGoogleTrackingTag = product => (
  // Global site tag (gtag.js) - Google Ads
  <Fragment>
    <Safe.script type="text/javascript" src="https://www.googletagmanager.com/gtag/js?id=AW-765192859" />
    <Safe.script type="text/javascript">
      {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-765192859');
      `}
    </Safe.script>
    {product ? (
      <Safe.script type="text/javascript">
        {`
            gtag('event', 'page_view', {
              'send_to': 'AW-765192859',
              'items': [{
                'id': ${product.product_id},
                'google_business_vertical': 'retail'
              }]
            });
          `}
      </Safe.script>
    ) : null}
  </Fragment>
);
const addFreshdeskScript = freshdeskMode => {
  return freshdeskMode === 'chatbot' ? (
    <Safe.script>
      {`
          (function (d, w, c) { if(!d.getElementById('spd-busns-spt')) {
            var n = d.getElementsByTagName('script')[0],
            s = d.createElement('script'); var loaded = false;
            s.id = 'spd-busns-spt'; s.async = 'async';
            s.src = 'https://cdn.freshbots.ai/assets/share/js/fbotsChat.min.js';
            s.setAttribute('data-prdct-hash', '72739a6abc259fc06bd3aae6d959178cf1ee37c7');
            s.setAttribute('data-region', 'us');
            s.setAttribute('data-ext-client-id', 'f8de1d1c7ec211e88b860acd63122558');if (c) {s.onreadystatechange = s.onload = function () { if (!loaded) { c(); } loaded = true; }; } n.parentNode.insertBefore(s, n); } })(document, window);
        `}
    </Safe.script>
  ) : (
    <Safe.script>
      {
        "var fc_CSS=document.createElement('link');fc_CSS.setAttribute('rel','stylesheet');var isSecured = (window.location && window.location.protocol == 'https:');var rtlSuffix = ((document.getElementsByTagName('html')[0].getAttribute('lang')) === 'ar') ? '-rtl' : '';fc_CSS.setAttribute('type','text/css');fc_CSS.setAttribute('href',((isSecured)? 'https://d36mpcpuzc4ztk.cloudfront.net':'http://assets1.chat.freshdesk.com')+'/css/visitor'+rtlSuffix+'.css');document.getElementsByTagName('head')[0].appendChild(fc_CSS);var fc_JS=document.createElement('script'); fc_JS.type='text/javascript';fc_JS.src=((isSecured)?'https://d36mpcpuzc4ztk.cloudfront.net':'http://assets.chat.freshdesk.com')+'/js/visitor.js';(document.body?document.body:document.getElementsByTagName('head')[0]).appendChild(fc_JS);window.freshchat_setting= 'eyJ3aWRnZXRfc2l0ZV91cmwiOiJpdGFsaXN0Y29tLmZyZXNoZGVzay5jb20iLCJwcm9kdWN0X2lkIjpudWxsLCJuYW1lIjoiaXRhbGlzdC5jb20iLCJ3aWRnZXRfZXh0ZXJuYWxfaWQiOm51bGwsIndpZGdldF9pZCI6ImM5MmEzOTA0LTUzMWUtNDliNS1iYzI0LWVlZjM0NmY0NzExZCIsInNob3dfb25fcG9ydGFsIjpmYWxzZSwicG9ydGFsX2xvZ2luX3JlcXVpcmVkIjpmYWxzZSwiaWQiOjYwMDAwNTU3MzAsIm1haW5fd2lkZ2V0Ijp0cnVlLCJmY19pZCI6ImVlZjkyOTA0NmJkY2M5OTVlNmYxZDZlOTc0MDM5NDdlIiwic2hvdyI6MSwicmVxdWlyZWQiOjIsImhlbHBkZXNrbmFtZSI6Iml0YWxpc3QuY29tIiwibmFtZV9sYWJlbCI6Ik5hbWUiLCJtYWlsX2xhYmVsIjoiRW1haWwiLCJtZXNzYWdlX2xhYmVsIjoiTWVzc2FnZSIsInBob25lX2xhYmVsIjoiUGhvbmUgTnVtYmVyIiwidGV4dGZpZWxkX2xhYmVsIjoiVGV4dGZpZWxkIiwiZHJvcGRvd25fbGFiZWwiOiJEcm9wZG93biIsIndlYnVybCI6Iml0YWxpc3Rjb 20 uZ nJl c2hkZXNrLmNvbSIsIm5vZGV1cmwiOiJjaGF0LmZyZXNoZGVzay5jb20iLCJkZWJ1ZyI6MSwibWUiOiJNZSIsImV4cGlyeSI6MTQ0NDczMjgxMzAwMCwiZW52aXJvbm1lbnQiOiJwcm9kdWN0aW9uIiwiZGVmYXVsdF93aW5kb3dfb2Zmc2V0IjozMCwiZGVmYXVsdF9tYXhpbWl6ZWRfdGl0bGUiOiJDaGF0IGluIHByb2dyZXNzIiwiZGVmYXVsdF9taW5pbWl6ZWRfdGl0bGUiOiJMZXQncyB0YWxrISIs ImRlZmF1bHRfdGV4dF9wbGFjZSI6IllvdXIgTWVzc2FnZSIsImRlZmF1bHRfY29ubmVjdGluZ19tc2ciOiJXYWl0aW5nIGZvciBhbiBhZ2VudCIsImRlZmF1bHRfd2VsY29tZV9tZXNzYWdlIjoiSGkhIEhvdyBjYW4gd2UgaGVscCB5b3UgdG9kYXk/IiwiZGVmYXVsdF93YWl0X21lc3NhZ2UiOiJPbmUgb2YgdXMgd2lsbCBiZSB3aXRoIHlvdSByaWdodCBhd2F5LCBwbGVhc2Ugd2FpdC4iLCJkZWZhdWx0X2FnZW50X2pvaW5lZF9tc2ciOiJ7e2FnZW50X25hbWV9fSBoYXMgam9pbmVkIHRoZSBjaGF0IiwiZGVmYXVsdF9hZ2VudF9sZWZ0X21zZyI6Int7YWdlbnRfbmFtZX19IGhhcyBsZWZ0IHRoZSBjaGF0IiwiZGVmYXVsdF9hZ2VudF90cmFuc2Zlcl9tc2dfdG9fdmlzaXRvciI6IllvdXIgY2hhdCBoYXMgYmVlbiB0cmFuc2ZlcnJlZCB0byB7e2FnZW50X25hbWV9fSIsImRlZmF1bHRfdGhhbmtfbWVzc2FnZSI6IlRoYW5rIHlvdSBmb3IgY2hhdHRpbmcgd2l0aCB1cy4gSWYgeW91IGhhdmUgYWRkaXRpb25hbCB xdW Vzd GlvbnMsIGZlZWwgZnJlZSB0byBwaW5nIHVzISIsImRlZmF1bHRfbm9uX2F2YWlsYWJpbGl0eV9tZXNzYWdlIjoiT3VyIGFnZW50cyBhcmUgdW5hdmFpbGFibGUgcmlnaHQgbm93LiBTb3JyeSBhYm91dCB0aGF0LCBidXQgcGxlYXNlIGxlYXZlIHVzIGEgbWVzc2FnZSBhbmQgd2UnbGwgZ2V0IHJpZ2h0IGJhY2suIiwiZGVmYXVsdF9wcmVjaGF0X21lc3NhZ2UiOiJXZSBjYW4ndCB3YWl0IHRvIHRhbGsgd G 8geW91LiBCdXQgZmlyc3QsIHBsZWFzZSB0ZWxsIHVzIGEgYml0IGFib3V0IHlvdXJzZWxmLiIsImFnZW50X3RyYW5zZmVyZWRfbXNnIjoiWW91ciBjaGF0IGhhcyBiZWVuIHRyYW5zZmVycmVkIHRvIHt7YWdlbnRfbmFtZX19IiwiYWdlbnRfcmVvcGVuX2NoYXRfbXNnIjoie3thZ2VudF9uYW1lfX0gcmVvcGVuZWQgdGhlIGNoYXQiLCJ2aXNpdG9yX3NpZGVfaW5hY3RpdmVfbXNnIjoiVGhpcyBjaGF0IGhhcyBiZWVuIGluYWN0aXZlIGZvciB0aGUgcGFzdCAyMCBtaW51dGVzLiIsImFnZW50X2Rpc2Nvbm5lY3RfbXNnIjoie3thZ2VudF9uYW1lfX0gaGFzIGJlZW4gZGlzY29ubmVjdGVkIiwic2l0ZV9pZCI6ImVlZjkyOTA0NmJkY2M5OTVlNmYxZDZlOTc0MDM5NDdlIiwiYWN0aXZlIjp0cnVlLCJ3aWRnZXRfcHJlZmVyZW5jZXMiOnsid2luZG93X2NvbG9yIjoiIzAwMDAwMCIsIndpbmRvd19wb3NpdGlvbiI6IkJvdHRvbSBSaWdodCIsIndpbmRvd19vZmZzZXQiOiIzMCIsInRleHRfcGxhY2UiOiJZb3VyIE1lc3NhZ2UiLCJjb25uZWN0aW5nX21zZyI6IldhaXRpbmcgZm9yIGFuIGFnZW50IiwiYWdlbnRfbGVmdF9tc2ciOiJ7e2FnZW50X25hbWV9fSBoYXMgbGVmdCB0aGUgY2hhdCIsImFnZW50X2pvaW5lZF9tc2ciOiJ7e2FnZW50X25hbWV9fSBoYXMgam9pbmVkIHRoZSBjaGF0IiwibWluaW1pemVkX3RpdGxlIjoiSG93IHdlIGNhbiBoZWxwIHlvdT8iLCJtYXhpbWl6ZWRfdGl0bGUiOiJDaGF0IGl uI HB yb2 dyZXNzIiw i d2VsY29tZV9tZXNzYWdlIjoiSGkhIEhvdyBjYW4gd2UgaGVscCB5b3UgdG9kYXk/IiwidGhhbmtfbWVzc2FnZSI6IlRoYW5rIHlvdSBmb3IgY2hhdHRpbmcgd2l0aCB1cy4gSWYgeW91IGhhdmUgYWRkaXRpb25hbCBxdWVzdGlvbnMsIGZlZWwgZnJlZSB0byBwaW5nIHVzISIsIndhaXRfbWVzc2FnZSI6Ik9uZSBvZiB1cyB3aWxsIGJlIHdpdGggeW91IHJpZ2h0IGF3YXksIHBsZWFzZSB3YWl0LiIsImFnZW50X3RyYW5zZmVyX21zZ190b192aXNpdG9yIjoiWW91ciBjaGF0IGhhcyBiZWVuIHRyYW5zZmVycmVkIHRvIHt7YWdlbnRfbmFtZX19In0sInJvdXRpbmciOnsiZHJvcGRvd25fYmFzZWQiOiJmYWxzZSIsImNob2ljZXMiOnsibGlzdDEiOlsiMCJdLCJsaXN0MiI6WyIwIl0sImxpc3QzIjpbIjAiXSwiZGVmYXVsdCI6WyIwIl19fSwicHJlY2hhdF9mb3JtIjp0cnVlLCJwcmVjaGF0X21lc3NhZ2UiOiJXZSBjYW4ndCB3YWl0IHRvIHRhbGsgdG8geW91LiBCdXQgZmlyc3QsIHBsZWFzZSB0ZWxsIHVzIGEgYml0IGFib3V0IHlvdXJzZWxmLiIsInByZWNoYXRfZmllbGRzIjp7Im5hbWUiOnsidGl0bGUiOiJOYW1lIiwic2hvdyI6IjIifSwiZW1haWwiOnsidGl0bGUiOiJFbWFpbCIsInNob3ciOiIyIn0sInBob25lIjp7InRpdGxlIjoiUGhvbmUgTnVtYmVyIn0sInRleHRmaWVsZCI6eyJ0aXRsZSI6IlRleHRmaWVsZCJ9LCJkcm9wZG93biI6eyJ0aXRsZSI6IkRyb3Bkb3duIiwib3B0aW9ucyI6WyJsa XN 0M SIs Imxpc3QyI i wibGlzdDMiXX19LCJidXNpbmVzc19jYWxlbmRhciI6bnVsbCwibm9uX2F2YWlsYWJpbGl0eV9tZXNzYWdlIjp7InRleHQiOiJPdXIgYWdlbnRzIGFyZSB1bmF2YWlsYWJsZSByaWdodCBub3cuIFNvcnJ5IGFib3V0IHRoYXQsIGJ1dCBwbGVhc2UgbGVhdmUgdXMgYSBtZXNzYWdlIGFuZCB3ZSdsbCBnZXQgcmlnaHQgYmFjay4iLCJjdXN0b21MaW5rIjoiMCIsImN1c3RvbUxpbmtVcmwiOiIifSwicHJvYWN0aXZlX2NoYXQiOmZhbHNlLCJwcm9hY3RpdmVfdGltZSI6MTUsInNpdGVfdXJsIjoiaXRhbGlzdGNvbS5mcmVzaGRlc2suY29tIiwiZXh0ZXJuYWxfaWQiOm51bGwsImRlbGV0ZWQiOmZhbHNlLCJvZmZsaW5lX2NoYXQiOnsic2hvdyI6IjEiLCJmb3JtIjp7Im5hbWUiOiJOYW1lIiwiZW1haWwiOiJFbWFpbCIsIm1lc3NhZ2UiOiJNZXNzYWdlIn0sIm1lc3NhZ2VzIjp7InRpdGxlIjoiTGVhdmUgdXMgYSBtZXNzYWdlISIsInRoYW5rIjoiVGhhbmsgeW91IGZvciB3cml0aW5nIHRvIHVzLiBXZSB3aWxsIGdldCBiYWNrIHRvIHlvdSBzaG9ydGx5LiIsInRoYW5rX2hlYWRlciI6IlRoYW5rIHlvdSEifX0sIm1vYmlsZSI6dHJ1ZSwiY3JlYXRlZF9hdCI6IjIwMTUtMTAtMDJUMTQ6NDc6NDYuMDAwWiIsInVwZGF0ZWRfYXQiOiIyMDE1LTEwLTAyVDE0OjUxOjUwLjAwMFoifQ==';"
      }
    </Safe.script>
  );
};

class TrackingScripts extends React.Component {
  render() {
    const { riskifiedDomain, riskifiedSessionId, runAdroll, adrollCustomData, googleProduct } = this.props;
    const { publicRuntimeConfig } = getConfig();
    const freshdeskMode = publicRuntimeConfig.freshdeskModeFeatureFlag;

    return (
      <Fragment>
        <Safe.script>
          {`
                (function() {
                    function riskifiedBeaconLoad() {
                        var store_domain = "${riskifiedDomain}";
                        var session_id = "${riskifiedSessionId}";
                        var url = ('https:' == document.location.protocol ? 'https://' : 'http://')
                            + "beacon.riskified.com?shop=" + store_domain + "&sid=" + session_id;
                        var s = document.createElement('script');
                        s.type = 'text/javascript';
                        s.async = true;
                        s.src = url;
                        var x = document.getElementsByTagName('script')[0];
                        x.parentNode.insertBefore(s, x);
                    }
                    if (window.attachEvent) {
                        window.attachEvent('onload', riskifiedBeaconLoad);
                    } else {
                        window.addEventListener('load', riskifiedBeaconLoad, false);
                    }
                })();
            `}
        </Safe.script>
        {addFreshdeskScript(freshdeskMode)}
        {PRODUCTION ? (
          <Fragment>
            <Safe.script>
              {`
                                var $embox_queue = [function () {
                                    new $embox(1148).hit();
                                }];
                                (function () {
                                    var s = document.createElement('script'), t = document.getElementsByTagName('script')[0];
                                    s.src = ('https:' == document.location.protocol ? 'https://tracking' : 'http://tools') + '.sembox.it/js/sembox-tracking-upgrade.js';
                                    t.parentNode.insertBefore(s, t);
                                }());
                            `}
            </Safe.script>
            <Safe.script type="text/javascript">
              {`
                                var google_conversion_id = 978756867;
                                var google_custom_params = window.google_tag_params;
                                var google_remarketing_only = true;
                            `}
            </Safe.script>
            <Safe.script type="text/javascript" src="//www.googleadservices.com/pagead/conversion.js" />
            <noscript>
              <div style={{ display: 'inline' }}>
                <img
                  height="1"
                  width="1"
                  style={{ borderStyle: 'none' }}
                  alt=""
                  src="//googleads.g.doubleclick.net/pagead/viewthroughconversion/978756867/?value=0&amp;guid=ON&amp;script=0"
                />
              </div>
            </noscript>
            {runAdroll && addAdrollScript(adrollCustomData)}
            {addGoogleTrackingTag(googleProduct)}
          </Fragment>
        ) : null}
      </Fragment>
    );
  }
}

export default TrackingScripts;
